// Design System Library - @estokai/ui
// Microcomponentes padronizados seguindo as melhores práticas do Angular 20

// === COMPONENTES BASE ===
export { AppButtonComponent } from './app-button.component';
export { AppInputComponent } from './app-input.component';
export {
  AppIconComponent,
  type IconSize,
  type IconColor,
} from './app-icon.component';
export {
  AppCardComponent,
  AppCardHeaderComponent,
  AppCardContentComponent,
  AppCardFooterComponent,
} from './app-card.component';
export { AppBadgeComponent } from './app-badge.component';
export {
  AppModalComponent,
  AppModalHeaderComponent,
  AppModalContentComponent,
  AppModalFooterComponent,
} from './app-modal.component';

// === NOVOS MICROCOMPONENTES ===
export { AppActionButtonComponent } from './app-action-button.component';
export { AppFormControlComponent } from './app-form-control.component';
export {
  AppStatsCardComponent,
  type StatItem,
} from './app-stats-card.component';
export {
  AppTableComponent,
  type TableColumn,
  type TableConfig,
} from './app-table.component';
export {
  AppNotificationComponent,
  type NotificationType,
} from './app-notification.component';
export { AppSimpleCardComponent } from './app-simple-card.component';
export { AppSpinnerComponent } from './app-spinner.component';

// === TIPOS E INTERFACES ===
export type {
  AppButtonVariant,
  AppButtonSize,
  AppButtonType,
} from './app-button.component';

export type { AppInputType, AppInputSize } from './app-input.component';

export type { AppCardVariant, AppCardPadding } from './app-card.component';

export type {
  AppBadgeVariant,
  AppBadgeSize,
  AppBadgeShape,
} from './app-badge.component';

export type { AppModalSize } from './app-modal.component';

// === CONSTANTES DO DESIGN SYSTEM ===
export const DESIGN_TOKENS = {
  colors: {
    primary: {
      50: '#E3F2FD',
      500: '#1A73E8', // Cor primária principal
      900: '#082C4C',
    },
    secondary: {
      50: '#FEF9E7',
      500: '#F7B32B', // Cor secundária principal
      900: '#995200',
    },
    accent: {
      50: '#FEF0ED',
      500: '#E4572E', // Cor de destaque principal
      900: '#861E02',
    },
  },
  spacing: {
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2rem',
  },
  borderRadius: {
    sm: '0.25rem',
    md: '0.5rem',
    lg: '0.75rem',
  },
  shadows: {
    soft: '0 2px 8px rgba(0, 0, 0, 0.08)',
    medium: '0 4px 16px rgba(0, 0, 0, 0.12)',
    strong: '0 8px 32px rgba(0, 0, 0, 0.16)',
  },
} as const;
